import script from "./PasswordRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordRegister.vue?vue&type=script&setup=true&lang=js"

import "./PasswordRegister.vue?vue&type=style&index=0&id=4df1cacf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df1cacf"]])

export default __exports__